import { DeviceDetailsServiceServiceMock } from "./deviceDetails.types";

export const mockDeviceDetailsService = (): DeviceDetailsServiceServiceMock => ({
  fetchDeviceDetailsById: jest.fn(),
});
